module.exports = __webpack_public_path__ + "img/organization-1-old-1.dbd09a88.jpg";